module.exports = __webpack_public_path__ + "static/img/cadillac_2.aff5887.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ios-bluetooth/cadillac_2.png
// module id = glfs
// module chunks = 215